export default async (goveoCategoryRepository) => {
    return await goveoCategoryRepository.fetch();
}
